if (!customElements.get('shipping-progress-bar')) {
  customElements.define(
    'shipping-progress-bar',
    class ShippingProgressBar extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.textElement = this.querySelector('.flex-shipping-bar__text');
        this.fillElement = this.querySelector('.flex-shipping-bar__fill');

        if (!this.threshold) return;

        this.refresh();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      refresh() {
        const cartUrl = window.routes ? `${window.routes.cart_url}.json` : '/cart.json';

        fetch(cartUrl)
          .then((response) => response.json())
          .then((cart) => this.render(cart))
          .catch(() => {});
      }

      render(cart) {
        const remaining = this.threshold - cart.total_price;
        this.hidden = false;

        if (remaining <= 0) {
          this.textElement.textContent = this.dataset.achievedText;
          this.fillElement.style.width = '100%';
          return;
        }

        const formatted = this.formatMoney(remaining, cart.currency);
        this.textElement.textContent = this.dataset.progressTemplate.replace('__AMOUNT__', formatted);
        const percent = Math.min(100, Math.max(0, ((this.threshold - remaining) / this.threshold) * 100));
        this.fillElement.style.width = `${percent}%`;
      }

      formatMoney(cents, currencyCode) {
        const amount = cents / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', {
            style: 'currency',
            currency: currencyCode || 'JPY',
            maximumFractionDigits: 0,
          }).format(amount);
        } catch (error) {
          return `¥${Math.round(amount).toLocaleString('ja-JP')}`;
        }
      }
    }
  );
}
